import { SHIPPING_METHOD_KEY_FREIGHT, SHIPPING_METHOD_KEY_PARCEL } from './shippingMethodKeys';

export const SHIPPING_TYPE = {
  PARCEL: SHIPPING_METHOD_KEY_PARCEL,
  FREIGHT: SHIPPING_METHOD_KEY_FREIGHT,
} as const;

export type ShippingTypes = ValueOf<typeof SHIPPING_TYPE>;
